import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IResults } from '@shared/iris.interface';

import { Observable } from 'rxjs';
import environment from '../../../../environments/environment';
import { getWorkspaceSitesListLength } from "@submissions/next/redux/submission.selectors";

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  private store = inject(Store);
  private http = inject(HttpClient);

  sitesLength$ = this.store.select(getWorkspaceSitesListLength);

  constructor() {}

  getSubmissionSites(
    submissionId: string,
    queryParams: HttpParams,
  ): Observable<any> {
    return this.http.get<IResults>(
      `${environment.irisApi}/workspace/${submissionId}/sites/`,
      { params: queryParams },
    );
  }

  getStudySites(studyId: string, queryParams: HttpParams): Observable<any> {
    return this.http.get<IResults>(
      `${environment.irisApi}/study/${studyId}/site/`,
      { params: queryParams },
    );
  }

  getSitesForStudyByRegion(
    studyId: string,
    queryParams: HttpParams,
  ): Observable<any> {
    return this.http.get<IResults>(
      `${environment.irisApi}/study/${studyId}/region_site/`,
      { params: queryParams },
    );
  }

  addSiteToSubmission(
    submissionId: string,
    siteIds: string[],
    reason?: string,
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.irisApi}/workspace/${submissionId}/sites/`,
      { site_ids: siteIds, ...(reason ? { reason } : {}) },
    );
  }

  removeSitesFromSubmission(
    submissionId: string,
    siteIds: string[],
    reason?: string,
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.irisApi}/workspace/${submissionId}/sites/`,
      { site_ids: siteIds, ...(reason ? { reason } : {}) },
    );
  }
}
